import { useEffect, useRef, useState } from 'react';
import { ModalContainer } from '../UtilitiesComponents/ModalContainer';
import { ChangeDealStageFormContainer } from '../PipelineComponents/ChangeDealStageForms/ChangeDealStageFormContainer';
import { ChangeAssignedProspectador } from './ChangeAssignedProspectador';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';

export function EmpresaOptionMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const modalRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if(modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    return (
        <>
        <div className='relative'>
            <div
                ref={buttonRef}
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center justify-center h-[36px] w-[36px] hover:bg-slate-200 ${isOpen ? "bg-slate-200" : ""} rounded cursor-pointer`}>
                <MoreVertRoundedIcon sx={{ width: 27, height: 27 }}/>
            </div>

            {isOpen && (
            <div
                ref={modalRef}
                className={`absolute shadow-lg bg-slate-50 rounded border border-gray-300 z-50 mt-[3px] right-0 w-[250px]`}>
                <div className="py-0 overflow-auto">
                    <div 
                        onClick={() => {
                            setShowModal(true);
                            setIsOpen(false);
                        }}
                        className="flex items-center gap-x-1 px-[10px] py-2 hover:bg-slate-100 cursor-pointer rounded">
                        <SwapHorizRoundedIcon sx={{ height: 15, width: 15 }}/>
                        <p className="font-semibold text-sm cursor-pointer">Cambiar prospectador asignado</p>
                    </div>
                </div>
            </div>
            )}
        </div>

        {showModal && (
            <ModalContainer>
                <ChangeDealStageFormContainer setShowModal={setShowModal}>
                    <ChangeAssignedProspectador
                        setShowModal={setShowModal}
                        onCancel={() => setShowModal(false)}/>
                </ChangeDealStageFormContainer>
            </ModalContainer>
        )}
        </>
    );
}